import { CreateOrderModel, PaginationModel } from '../models';
import { CreateOrderSchema } from '../schemas';
import { validateWithSchema } from '../utils';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getOrders = async (pagination: PaginationModel): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/orders?page=${pagination.page}&limit=${pagination.limit}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const postOrder = async (newOrder: CreateOrderModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post(`/orders/`, validateWithSchema(CreateOrderSchema, newOrder))
      .then((response) => handleResponse(response))
      .catch(handleError);
};
